import { useQueryClient } from '@tanstack/react-query'

import { FormSection } from '../../../components/ui/form/form-section'
import { AddBonusButton } from '../../../loyalty/components/bonus/add-bonus-button'
import { EditBonusRule } from '../../../loyalty/components/bonus/edit-bonus-rule'
import { broadcastQueryKeys } from '../queries'

import type { LoyaltyBonusRule } from '../../../loyalty/loyalty-bonus.schema'

type Props = {
  broadcastBonus: LoyaltyBonusRule | null
  broadcastId: string
  onDelete: () => void
  onSubmit: (bonusId: string) => void
}

function BroadcastBonus({
  broadcastBonus,
  broadcastId,
  onDelete,
  onSubmit,
}: Props) {
  const queryClient = useQueryClient()

  return (
    <>
      {!broadcastBonus ? (
        <div className="py-2">
          <AddBonusButton availability="range" onSubmit={onSubmit} />
        </div>
      ) : (
        <FormSection>
          <EditBonusRule
            availability="range"
            bonusRule={broadcastBonus}
            onDelete={onDelete}
            onEdit={() =>
              queryClient.invalidateQueries(
                broadcastQueryKeys.detail(broadcastId)
              )
            }
          />
        </FormSection>
      )}
    </>
  )
}

export { BroadcastBonus }
